import ModelDelete from "@/pages/modals/_delete";
import { useDeleteUnitCodeMutation } from "@/services/unitcode.service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function Delete() {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [deleteUnitCode, {isSuccess}] = useDeleteUnitCodeMutation()

    const onAccept = () => {
        deleteUnitCode(location.state?.id || "")
    }

    useEffect(() => {
        if (isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])
    
    return <ModelDelete title={t("modal.delete_unitcode")} content={t("modal.delete_unitcode_content")} onAccept={onAccept} />
}
